export var tableWrap = {
  overflowX: 'auto',
  marginBottom: '2em'
};
export var reportTable = function reportTable(theme) {
  return {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '1.25rem',
    '& thead': {
      backgroundColor: theme.gray50,
      '& th': {
        padding: '1em 0.8em',
        fontWeight: 600,
        color: theme.gray400,
        textAlign: 'left',
        whiteSpace: 'nowrap',
        borderBottom: "2px solid ".concat(theme.gray100)
      }
    },
    '& tbody': {
      '& tr': {
        borderBottom: "1px solid ".concat(theme.gray100),
        transition: 'background-color 0.15s ease',
        '&:hover': {
          backgroundColor: theme.gray50
        }
      },
      '& td': {
        padding: '0.9em 0.8em',
        color: theme.gray700,
        whiteSpace: 'nowrap'
      },
      '& td:last-of-type': {
        width: 1
      }
    }
  };
};
export var emptyState = function emptyState(theme) {
  return {
    padding: '3em 2em',
    textAlign: 'center',
    color: theme.gray400,
    fontSize: '1.3rem'
  };
};